export default "__VITE_ASSET__YJhhV5QE__"